<template>
  <div class="file-preview" :class="{ 'inverse': inverse }">
    <div class="file-icon">
      <font-awesome-icon :icon="iconClass" />
    </div>
    <div class="file-info">
      <div class="file-name">{{ fileName }}</div>
      <div class="file-size">{{ fileSize }}</div>
    </div>
    <div class="file-actions">
      <img :src="getPreview(file)" v-if="isPreviewable" width="40">
<!--      <p v-else class="file-preview-text">No preview...</p>-->
      <a v-if="download" :href="fileUrl" :download="fileName" class="btn btn-secondary btn-sm">
        <font-awesome-icon icon="fa-download" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useWidgetStore } from '@/store'

const previewableTypes = ['jpg', 'jpeg', 'png', 'gif']

export default {
  props: {
    file: {
      type: Object,
      required: true
    },
    download: {
      type: Boolean,
      default: true
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(useWidgetStore, { fileLimitsConfig: 'fileLimits' }),
    fileName () {
      return this.file.name
    },
    fileLimits () {
      return this.fileLimitsConfig && typeof this.fileLimitsConfig === 'string' ? JSON.parse(this.fileLimitsConfig) : this.fileLimitsConfig
    },
    fileSize () {
      if (this.file && this.file.size) {
        let bytes = this.file.size
        const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        let i = 0
        while (bytes >= 1024 && i < units.length - 1) {
          bytes /= 1024
          i++
        }
        return `${bytes.toFixed(2)} ${units[i]}`
      }

      return 0
    },
    iconClass () {
      const extension = this.file.name.split('.').pop().toLowerCase()
      if (this.fileLimits.uploadFileTypes.includes(extension)) {
        if (previewableTypes.includes(extension)) {
          return 'file-image'
        }
        return `file-${extension}`
      } else {
        return 'file'
      }
    },
    fileUrl () {
      if (this.file && this.file.data) {
        return `data:${this.file.type};base64, ${this.file.data}`
      }

      return ''
    },
    isPreviewable () {
      const extension = this.file.name.split('.').pop().toLowerCase()
      return previewableTypes.includes(extension)
    }
  },
  beforeUnmount () {
    URL.revokeObjectURL(this.fileUrl)
  },
  methods: {
    getPreview (file) {
      return `data:${file.type};base64, ${file.data}`
    }
  }
}
</script>

<style scoped>
.file-preview {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 5px;
  background-color: #f5f5f5;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.inverse {
  background-color: #d2d2d2;
}
.file-icon {
  margin-right: 10px;
  font-size: 20px;
  color: #777;
}
.file-preview-text {
  font-size: 10px;
}
.file-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.file-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
.file-size {
  font-size: 12px;
  color: #777;
}
.file-actions {
  margin-left: auto;
}
.file-actions .btn {
  display: inline-block;
  margin-left: 10px;
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 4px;
}
.file-actions .btn-primary {
  color: #fff;
  background-color: #337ab7;
  border-color: #2e6da4;
}
.file-actions .btn-secondary {
  color: #333 !important;
  background-color: #fff;
  border-color: #ccc;
  width: auto;
}
.fa {
  font-family: FontAwesome;
}
.fa-file-o:before {
  content: '\f016';
}

.fa-file-pdf-o:before {
  content: '\f1c1';
}
.fa-file-excel-o:before,
.fa-file-xlsx-o:before,
.fa-file-csv-o:before {
  content: '\f1c3';
}
.fa-file-word-o:before,
.fa-file-doc-o:before,
.fa-file-docx-o:before {
  content: '\f1c2';
}
.fa-file-powerpoint-o:before,
.fa-file-ppt-o:before,
.fa-file-pptx-o:before {
  content: '\f1c4';
}
.fa-file-archive-o:before,
.fa-file-zip-o:before {
  content: '\f1c6';
}
.fa-file-image-o:before,
.fa-file-jpg-o:before,
.fa-file-jpeg-o:before,
.fa-file-png-o:before,
.fa-file-gif-o:before,
.fa-file-bmp-o:before,
.fa-file-tif-o:before {
  content: '\f1c5';
}
.fa-file-text-o:before,
.fa-file-txt-o:before {
  content: '\f0f6';
}
</style>
